/**
 * swireOpsInstance模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const swireOpsInstance = {
  // 下载Excel文件
  exportInstanceTask(params) {
    return $http.post(`${global.API_URL}/sme/swireOpsInstance/exportInstanceTask`,params,{responseType: 'arraybuffer'});
  },
  //日程列表分页
  pageSwireOpsInstance(params) {
    return $http.post(`${global.API_URL}/sme/swireOpsInstance/page`,params);
  }
}

export default swireOpsInstance;



// WEBPACK FOOTER //
// ./src/api/swireOpsInstance.js